export function formatFileSize(fileSize: number): string {
    const formattedSize =
        fileSize >= 1000000
            ? `${(fileSize / 1000000).toFixed(2)} MB`
            : fileSize >= 1000
            ? `${(fileSize / 1000).toFixed(2)} KB`
            : `${fileSize.toFixed(1)} Byte`
    return formattedSize
}
